import React, { Component } from 'react';
import Jumbotron from 'react-bootstrap/Jumbotron'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card'
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';

const IOSSwitch = withStyles((theme) => ({
    root: {
        width: 42,
        height: 26,
        padding: 0,
        margin: theme.spacing(1),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 24,
        height: 24,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

export default class VideoInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { selectedVideo } = { ...this.props };

        const steps = selectedVideo.steps.split(/[0-9]+.\s/);

        if (steps.length > 0) {
            //  Se borra el primer registro (vacio)
            steps.splice(0, 1);
        } else {
            steps = null;
        }

        return (
            <>
                {/*<Row style={{ textAlign: "center" }}>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Card>
                            <Card.Body>
                                <Card.Title>Reproducción automática <IOSSwitch checked={true} onChange={() => { }} name="automaticPlay" /></Card.Title>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>*/}
                <Row>
                    {
                        selectedVideo.title && selectedVideo.title.length > 0 ?
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Card>
                                    <Card.Body>
                                        <Card.Title><h2>{selectedVideo.title}</h2></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            :
                            ""
                    }
                </Row>
                <Row>
                    {
                        selectedVideo.description && selectedVideo.description.length > 0 ?
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Card>
                                    <Card.Body>
                                        <Card.Title>Descripción</Card.Title>
                                        <Card.Text>{selectedVideo.description}</Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                            :
                            ""
                    }
                </Row>
                <Row>
                    {
                        steps && steps.length > 0 ?
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Card>
                                    <Card.Body>
                                        <Card.Title>Paso a paso</Card.Title>
                                        <Card.Text>
                                            <ol>
                                                {
                                                    steps.map((step, index) => {
                                                        return <li key={index}>{step}</li>
                                                    })
                                                }
                                            </ol>
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                            :
                            ""
                    }
                </Row>
            </>
        )
    }
}